import React from 'react'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import { POSTPAIDBALANCE_API, PREPAIDBALANCE_API } from '../../services/common/endpoints';
import Loadingcomponent from '../loader/loadingcomponent';
import BalanceCardShimmer from '../../components/loader/skeletons/common/balance-card';

function BalanceCard() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const customerprofile = useSelector(
        (state) => state?.userdata?.value?.customerprofile || {}
    );

    const isPostpaid = customerprofile?.RatePlanType === 'POSTPAID';

    const balanceQr = useQuery(
        isPostpaid
            ? ['postpaid-balance', POSTPAIDBALANCE_API, { includeocc: 'false' }, {}]
            : ['prepaid-balance', PREPAIDBALANCE_API, { msisdn: '', transactionid: '' }, {}],
        {
            enabled: !!customerprofile?.RatePlanType,
            retry: false,
            cacheTime: 0,
            staleTime: 0,
        }
    );

    if (balanceQr.isLoading) {
        // return <Loadingcomponent />
        return <BalanceCardShimmer isPostpaid={isPostpaid} />
    }

    const balanceData = balanceQr?.data?.data?.response;

    const handlePayNowOrRecharge = () => {
        navigate("/recharge", { state: isPostpaid ? balanceData?.dueamount : balanceData?.totalbalance })
    }

    return (
        <div class="white_card dashboard_card mt-30">
            <div class="flex_grp_between ">
                <div class="balance_section_info">
                    <label>
                        {isPostpaid
                            ? t("dueamount")
                            : t("balance")}
                    </label>
                    <h3 class="balance">
                        {isPostpaid
                            ? `${balanceData?.currency || ''} ${balanceData?.dueamount || ''}`
                            : `${balanceData?.currency || ''} ${balanceData?.totalbalance || ''}`
                        }
                    </h3>
                    {isPostpaid && (balanceData?.dueamount && parseFloat(balanceData?.dueamount)) > 0 &&
                        <div className="dls13-paybefore">{`${balanceData?.rnlabel} ${balanceData?.rnlastbillrundate}`}</div>
                    }
                    {isPostpaid ? (
                        <Link
                            // to="/viewbill"
                            to="/your-bill"
                            className="custom_btn custom_btn_sm custom_btn_primary_outline mt-3"
                        >
                            {t("viewbill")}
                        </Link>
                    ) : (
                        <>
                            {
                                balanceData?.totalbalance > 0 && !balanceData?.rnexpirydate?.includes('--T') && (
                                    <p className="m-0">
                                        {t("expireson")} {balanceData?.rnexpirydate}
                                    </p>
                                )
                            }
                        </>

                    )}
                </div>
                <div class={`balance_section_action ${isPostpaid ? "" : 'align-self-center'}`}>
                    <button
                        onClick={handlePayNowOrRecharge}
                        class="custom_btn custom_btn_sm custom_btn_primary text-initials"
                    >
                        {isPostpaid
                            ? t("paynow")
                            : t("recharge")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BalanceCard